import Api from 'app/helpers/api'
import i18n from 'app/helpers/i18n'

export const knowledgeComponentsSlice = ((set, get) => ({
  actions: {
    createKnowledgeComponent: async (params, callback) =>{
      if (params.knowledge_component.title.trim() === '') return;

      const api = new Api();
      await api.createKnowledgeComponent(params)
        .then((response) => {
          try{
            callback();
          }catch(error){
          }
          set((state) => ({ course: response.data.course }));
                    
          get().actions.setSnackMessage({show: true, type:"SUCCESS",text: i18n.t("Knowledge component saved")})

        })
      .catch((err) => {
        console.log(err)
        get().actions.setSnackMessage({show: true, type:"WARNING",text: i18n.t(err.response.data[0].message)});
      });
    },

    deleteKnowledgeComponent: async (params, callback) =>{
      const api = new Api();
      await api.deleteKnowledgeComponent(params)
        .then((response) => {
          try{
            callback();
          }catch(error){
          }
          set((state) => ({ course: response.data.course }));
                    
          get().actions.setSnackMessage({show: true, type:"SUCCESS",text: i18n.t("Knowledge component removed")})
        })
      .catch((err) => {
        console.log(err)
        get().actions.setSnackMessage({show: true, type:"WARNING",text: i18n.t(err.response.data[0].message)});
      });
    }

  }

}))